import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedLink } from 'src/features/nav/store/slice';
import { fetchSelectedApplication } from 'src/features/nav/store/slice.actions';
import { NavMetricPublisher } from 'src/commons/utils/metrics';

export default (): void => {
  const dispatch = useDispatch();
  const currentApplication = useSelector(selectSelectedLink);

  let currentUrl = window.location.pathname;
  const intervalCallback = (): void => {
    if (!!currentUrl && window.location.pathname !== currentUrl) {
      currentUrl = window.location.pathname;
      dispatch(fetchSelectedApplication());
      NavMetricPublisher.publishCounterMonitor(`ClientSideRoutingEvent`, 1);
    }
  };

  useEffect(() => {
    if (currentApplication?.isCSREnabled) {
      const interval = setInterval(intervalCallback, 50);
      return () => clearInterval(interval);
    }
  }, [currentApplication?.isCSREnabled]);
};
